<template>
  <div class='service-list'>

    <van-tabs class='job_types' type="card" @click='switchType' v-show='jobTypeList.length'>
      <van-tab title="全部"></van-tab>
      <van-tab v-for="(type, index) in jobTypeList" :key='index' :title="type.name"></van-tab>
    </van-tabs>

    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="job_list">
        <ServiceItem v-for='(job, index) in jobList' :key='index' :job='job'></ServiceItem>
      </div>
    </van-list>

  </div>
</template>

<script>
import ServiceItem from './ServiceItem';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      jobTypeList: [],
      jobList: [],
      categoryId: '',
      // 当前筛选类型
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: false,
      finished: false,
    };
  },
  methods: {

    loadMore() {
      if (this.jobList.length >= this.total) {
        return;
      }
      this.loading = true;
      this.condition.currPage++;
      this.getJobList();
    },

    getJobTypeListList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/service/category/list`, {
        parkId: this.currentParkId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.jobTypeList = res.resData.pageList ? res.resData.pageList : [];
        }
      });
    },
    getJobList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/hr/service/info/list`, {
        ...this.condition,
        parkId: this.currentParkId,
        categoryId: this.categoryId,
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.jobList = this.jobList.concat(tempArr);
          this.finished = this.jobList.length >= this.total ? true : false;
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    // 类型筛选
    switchType(key) {
      this.categoryId = key === 0 ? '' : this.jobTypeList[key-1].id;
      this.condition.currPage = 1;
      this.jobList = [];
      this.getJobList();
    },
  },
  components: { ServiceItem },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  created() {
    this.getJobTypeListList();
    this.getJobList();
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.service-list{
  .job_types{
    margin-top: .346667rem;
  }
  .job_list{
    margin-top: .346667rem;
    padding: .346667rem;
    border-top: .013333rem solid rgb(200, 200, 200);
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/humanResource/components/ServiceList.vue